/**
 * @generated SignedSource<<b9d31f2002f41f50df56a7fc2d0dd7f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContainerWithSidebar_sidebar",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasSections",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Sidebar_sidebar"
    }
  ],
  "type": "Sidebar",
  "abstractKey": null
};

node.hash = "3497852be953c5651fb3d1428263e604";

module.exports = node;
